import { isProtocolKey, ProtocolKey } from "@silo/types";
import { Menu, MenuButton, MenuItem, MenuList } from "../menu";
import { ProtocolDisplay } from "../protocol-display";
import { Tooltip, TooltipContent, TooltipOrigin } from "../tooltip";
import { Button } from "../button";
import { ChevronDownIcon } from "../../icons";
import { TooltipDescriptionContent } from "../description";

export interface ProtocolMenuProps {
  protocolKey: ProtocolKey;
  runtimeProtocolKeys: ProtocolKey[];
  setProtocol: (value: ProtocolKey) => void;
  showProtocolLabel: boolean;
  isAttemptingChainUpdate: boolean;
}

export function ProtocolMenu({
  protocolKey,
  runtimeProtocolKeys,
  setProtocol,
  showProtocolLabel,
  isAttemptingChainUpdate,
}: ProtocolMenuProps): JSX.Element {
  const menuButtonContent = (
    <ProtocolDisplay.Root>
      <ProtocolDisplay.Icon protocolKey={protocolKey} />

      {showProtocolLabel && <ProtocolDisplay.Label protocolKey={protocolKey} />}
    </ProtocolDisplay.Root>
  );

  if (isAttemptingChainUpdate) {
    return (
      <Tooltip placement="bottom-start" openDelay={400}>
        <TooltipOrigin>
          <Button
            disabled
            className="w-full px-2.5 flex gap-2 items-center"
            variant="tertiary"
            data-cy="protocol-instance-menu"
          >
            {menuButtonContent}

            <span>
              <ChevronDownIcon className="w-5 h-5" />
            </span>
          </Button>
        </TooltipOrigin>
        <TooltipContent>
          <TooltipDescriptionContent>
            Accept or cancel the network switch request in your wallet to access
            other Silo editions.
          </TooltipDescriptionContent>
        </TooltipContent>
      </Tooltip>
    );
  }

  function setSelectedId(value: string): void {
    if (isProtocolKey(value)) {
      setProtocol(value);
    }
  }

  return (
    <Menu
      id="protocol-menu"
      selectedId={protocolKey}
      setSelectedId={setSelectedId}
    >
      <div>
        <MenuButton
          className="w-full px-2.5"
          variant="tertiary"
          data-cy="protocol-instance-menu"
        >
          {menuButtonContent}
        </MenuButton>

        <MenuList className="z-50">
          {runtimeProtocolKeys.map((_protocolKey) => (
            <MenuItem key={_protocolKey} id={_protocolKey}>
              <ProtocolDisplay protocolKey={_protocolKey} />
            </MenuItem>
          ))}
        </MenuList>
      </div>
    </Menu>
  );
}
